import React, { useEffect, useState, useContext } from "react";
import DocContext from "./Context/DocContext";
import DocumentListItem from "./DocumentListItem";
import fetchClass from "../shared/httpClass";
import api from "../../Constants/api";
import Loader from "../shared/Loader";
import Pagination from "../shared/Paginator/Pagination";
import { SPONSOR_LETTER } from "../../Constants/childLetter";

const DocumentList = ({ child, type, daterange }) => {
    const { store, disableMenu, viewMessage, clearMessage, pid } = useContext(
        DocContext
    );
    const { menuDisabled } = store;
    const [childFiles, setChildFiles] = useState([]);

    let mounted = true;

    // console.log()

    // useEffect(() => {
    //     // console.log('changed', childFiles);
    //     if (child === null || !type) return;

    //     if (!mounted) {
    //         console.log("not mounted");
    //         return;
    //     }

    //     clearMessage();
    //     requestData(1);

    //     return () => {
    //         mounted = false;
    //     };
    // }, [child]);

    useEffect(() => {
        // console.log("selected child id", store.selectedChildId);
        if (child === null || !type) return;

        if (!mounted) {
            console.log("not mounted");
            return;
        }

        clearMessage();
        requestData(1);

        return () => {
            mounted = false;
        };
    }, [store.selectedChildId, type, daterange]);

    // function getDaterange(endpoint) {
    //     if (daterange) {
    //         return endpoint = endpoint + '?daterange=' + JSON.stringify(daterange);
    //     }

    //     return endpoint;
    // }

    function request(endpoint, params) {
        const endpointUrl = new URL(endpoint);

        if (pid) {
            if (params) {
                params.pid = pid;
            } else {
                params = { pid };
            }
        }

        endpointUrl.search = new URLSearchParams(params);

        const request = new fetchClass(endpointUrl, "GET");

        // const request = new fetchClass(endpoint, "GET");

        let response = request.http();

        return response;
    }

    function getChildFiles(url, childId, type, perPage, page) {
        let endpoint = `${url}/child/get-child-file/${childId}/${type}/${perPage}/${page}`;
        // endpoint = getDaterange(endpoint);

        const params = { daterange: JSON.stringify(daterange) };

        return request(endpoint, params);
    }

    function getAllChildFiles(url, childId, perPage, page) {
        let endpoint = `${url}/child/get-all-child-files/${childId}/${perPage}/${page}`;

        const params = { daterange: JSON.stringify(daterange) };

        return request(endpoint, params);
    }

    function getChildLetters(url, page, child_id = null) {
        if (!page) page = 1;

        // let endpoint = `${url}/web/get-child-letters?page=` + page + '&daterange=' + JSON.stringify(daterange);
        let endpoint = `${url}/web/get-child-letters?page=` + page;
        const params = { page, daterange: JSON.stringify(daterange) };

        if (child_id) params.child = child_id;//Added [child] filter

        return request(endpoint, params);
    }

    const requestData = page => {
        disableMenu();

        let request;

        if (type === SPONSOR_LETTER.code) {

            request = getChildLetters(api.urlV1, page, store.selectedChildId);

        } else if (type === "ALL") {
            // request = getAllChildFiles(api.urlV2, child.child_id, 7, page);
            request = getAllChildFiles(
                api.urlV2,
                store.selectedChildId,
                7,
                page
            );

        } else {
            // request = getChildFiles(api.urlV2, child.child_id, type, 7, page);
            request = getChildFiles(
                api.urlV2,
                store.selectedChildId,
                type,
                7,
                page
            );
        }

        // switch (type) {
        //     case SPONSOR_LETTER.code:
        //         request = getChildLetters(api.urlV1, page);
        //         break;
        //     case null:
        //         request = getAllChildFiles(api.urlV2, child.child_id, 7, page);
        //     default:
        //         request = getChildFiles(
        //             api.urlV2,
        //             child.child_id,
        //             type,
        //             7,
        //             page
        //         );
        // }

        request.then(res => {
            if (res && res.data) {
                setChildFiles(res);
            }

            setTimeout(() => {
                disableMenu();
            }, 500);
        });
    };

    const handleClick = (e, index) => {
        e.preventDefault();

        viewMessage(childFiles.data, index);
    };

    return (
        <div className="document-viewer-documents">
            {menuDisabled && <Loader width="40px" />}
            {childFiles.data && childFiles.data.length > 0
                ? !menuDisabled &&
                  childFiles.data.map((files, i) => {
                      return (
                          <DocumentListItem
                              key={i}
                              index={i}
                              type={type}
                              files={files}
                              click={handleClick}
                          />
                      );
                  })
                : !menuDisabled && <p>No results</p>}

            <Pagination data={childFiles} changePage={requestData} />

            {/* 2022 */}
            <p className="text-center" style={{color: '#999'}}>Note: Only include the child's first name when sharing letters online (no other information).</p>
        </div>
    );
};

export default DocumentList;
